import styled from '@emotion/styled';
import CircularProgress from '@mui/material/CircularProgress';

const LoaderOverlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.4);
`;

const StyledLoader = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;

export const Loader = () => {
    return (
        <LoaderOverlay data-testid="media-tile-loader">
            <StyledLoader>
                <CircularProgress size={20} />
            </StyledLoader>
        </LoaderOverlay>
    );
};
